import React from 'react'
import compose from 'recompose/compose'
import _ from 'lodash'
import PropTypes from 'prop-types'
import * as S from './styled'
import Button from '@material-ui/core/Button'
import { withI18n } from '../../hocs'
import { InputEditor } from '../../atoms'
import ActionDialog from '../action-dialog'

const ModalCreateObservation = ({ i18n, onSubmit }) => {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    reset()
    setOpen(false)
  }

  const [text, setText] = React.useState('')
  const handleChangeText = text => {
    setText(text)
  }

  const handleSubmit = e => {
    e && e.preventDefault()

    const data = {
      change_msg: text
    }

    // Si onSubmit devuelve la petición, el modal se cierra cuando ha ido bien; en error sigue abierto
    return Promise.resolve(onSubmit(data)).then(() => handleClose())
  }

  const reset = () => {
    setText('')
  }

  const isSubmitReady = !_.isEmpty(text)

  return (
    <div>
      <Button variant="contained" color="default" onClick={handleOpen} className="planning-btn">
        {i18n.process.createComment}
      </Button>
      <ActionDialog
        open={open}
        title={i18n.process.createComment}
        onClose={handleClose}
        onConfirm={handleSubmit}
        cancelLabel={i18n.dialog.decline}
        confirmLabel={i18n.process.createComment}
        confirmDisabled={!isSubmitReady}
        disableBackdropClose
      >
        <S.Label>{i18n.process.text}*</S.Label>
        <InputEditor name="title" placeholder={i18n.process.commentName} onChange={handleChangeText} value={text} />
      </ActionDialog>
    </div>
  )
}

ModalCreateObservation.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  inboxFilters: PropTypes.array,
  onSubmit: PropTypes.func.isRequired
}

const enharce = compose(withI18n)

export default enharce(ModalCreateObservation)
